import './cart';
import './coupon';
import './download';
import './isotope';
import './lasktop-nav';
import './phablet';
import './quantity';
import './single';
import './sliders';
import './videos';